import React from "react";

const DashboardMeditationBG = ({ className, ...props }) => {
  return (
    <svg
      width="944"
      height="1199"
      viewBox="0 0 944 1199"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g filter="url(#filter0_f_2918_7926)">
        <path
          d="M434.5 1129L509.5 1129L618 887L327 887L434.5 1129Z"
          fill="url(#paint0_linear_2918_7926)"
        />
      </g>
      <g filter="url(#filter1_d_2918_7926)">
        <path
          d="M400.94 452.919C401.427 449.56 398.888 447.751 395.413 446.537L396.542 441.99L393.798 441.292L392.695 445.684C391.977 445.491 391.233 445.323 390.49 445.155L391.592 440.685L388.848 440L387.72 444.547L385.976 444.134L382.129 443.165L381.437 446.124C381.437 446.124 383.475 446.602 383.437 446.627C383.812 446.682 384.152 446.88 384.386 447.181C384.621 447.482 384.731 447.862 384.694 448.242L383.411 453.41C383.509 453.428 383.604 453.458 383.693 453.5L383.411 453.449L381.629 460.67C381.588 460.799 381.523 460.918 381.436 461.02C381.349 461.123 381.243 461.208 381.124 461.269C381.005 461.33 380.875 461.367 380.741 461.377C380.608 461.388 380.474 461.371 380.347 461.329C380.347 461.329 378.346 460.825 378.346 460.825L377 464.055L380.578 464.946L382.539 465.463L381.398 470.062L384.155 470.76L385.283 466.199C386.027 466.406 386.758 466.6 387.476 466.768L386.348 471.315L389.105 472L390.246 467.401C394.939 468.292 398.465 467.943 399.953 463.654C401.145 460.218 399.953 458.229 397.388 456.937C398.336 456.752 399.197 456.259 399.839 455.533C400.48 454.807 400.867 453.888 400.94 452.919ZM394.644 461.794C393.798 465.243 388.04 463.383 386.181 462.918L387.681 456.795C389.553 457.234 395.529 458.164 394.644 461.742V461.794ZM395.503 452.867C394.721 455.994 389.938 454.405 388.374 454.017L389.746 448.436C391.297 448.824 396.311 449.547 395.503 452.816V452.867Z"
          fill="#FFB240"
        />
      </g>
      <g filter="url(#filter2_f_2918_7926)">
        <circle
          cx="472"
          cy="472"
          r="372"
          fill="url(#paint1_radial_2918_7926)"
        />
      </g>
      <g filter="url(#filter3_d_2918_7926)">
        <path
          d="M666.299 786.486L672 783.167L677.702 786.486L675.606 787.712L672 785.619L668.395 787.712L666.299 786.486ZM677.702 790.671L675.606 789.445L672 791.538L668.395 789.445L666.299 790.671V793.123L669.904 795.216V799.401L672 800.627L674.096 799.401V795.216L677.702 793.123V790.671ZM677.702 797.308V794.856L675.606 796.082V798.534L677.702 797.308ZM679.19 798.175L675.585 800.268V802.72L681.286 799.401V792.764L679.19 793.99V798.175ZM677.094 788.578L679.19 789.804V792.256L681.286 791.03V788.578L679.19 787.352L677.094 788.578ZM669.904 801.156V803.608L672 804.834L674.096 803.608V801.156L672 802.382L669.904 801.156ZM666.299 797.308L668.395 798.534V796.082L666.299 794.856V797.308ZM669.904 788.578L672 789.804L674.096 788.578L672 787.352L669.904 788.578ZM664.811 789.804L666.907 788.578L664.811 787.352L662.715 788.578V791.03L664.811 792.256V789.804ZM664.811 793.99L662.715 792.764V799.401L668.416 802.72V800.268L664.811 798.175V793.99Z"
          fill="#FFD84F"
        />
      </g>
      <g filter="url(#filter4_d_2918_7926)">
        <path
          d="M615.661 556.723V568.916L625.967 573.521L615.661 556.723Z"
          fill="white"
          fillOpacity="0.6"
        />
        <path
          d="M615.659 556.723L605.352 573.521L615.659 568.916V556.723Z"
          fill="white"
        />
        <path
          d="M615.661 581.423V589.708L625.973 575.44L615.661 581.423Z"
          fill="white"
          fillOpacity="0.6"
        />
        <path
          d="M615.659 589.708V581.422L605.352 575.44L615.659 589.708Z"
          fill="white"
        />
        <path
          d="M615.661 579.504L625.967 573.52L615.661 568.918V579.504Z"
          fill="white"
          fillOpacity="0.4"
        />
        <path
          d="M605.352 573.52L615.659 579.504V568.918L605.352 573.52Z"
          fill="white"
          fillOpacity="0.6"
        />
      </g>
      <g filter="url(#filter5_d_2918_7926)">
        <path
          d="M285.5 707.25C279.287 707.25 274.25 712.287 274.25 718.5C274.25 724.713 279.288 729.75 285.5 729.75C291.713 729.75 296.75 724.714 296.75 718.5C296.75 712.286 291.714 707.25 285.5 707.25Z"
          fill="#53AE94"
        />
        <path
          d="M284.111 717.001V715.327H280.284V712.777H290.706V715.327H286.878V716.999C289.989 717.142 292.328 717.758 292.328 718.496C292.328 719.234 289.988 719.85 286.878 719.994V725.355H284.111V719.994C281.006 719.85 278.671 719.235 278.671 718.498C278.671 717.76 281.006 717.145 284.111 717.001M284.111 719.54V719.538C284.189 719.543 284.59 719.567 285.483 719.567C286.197 719.567 286.7 719.547 286.877 719.538V719.54C289.625 719.418 291.676 718.94 291.676 718.367C291.676 717.795 289.625 717.317 286.877 717.195V719.063C286.697 719.076 286.182 719.106 285.471 719.106C284.618 719.106 284.189 719.071 284.11 719.063V717.195C281.367 717.317 279.321 717.796 279.321 718.367C279.321 718.937 281.368 719.416 284.11 719.539"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_2918_7926"
          x="257"
          y="817"
          width="431"
          height="382"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="35"
            result="effect1_foregroundBlur_2918_7926"
          />
        </filter>
        <filter
          id="filter1_d_2918_7926"
          x="341"
          y="408"
          width="104"
          height="112"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="4" dy="8" />
          <feGaussianBlur stdDeviation="20" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.966667 0 0 0 0 0.648409 0 0 0 0 0.177222 0 0 0 0.6 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2918_7926"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2918_7926"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_f_2918_7926"
          x="0"
          y="0"
          width="944"
          height="944"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="50"
            result="effect1_foregroundBlur_2918_7926"
          />
        </filter>
        <filter
          id="filter3_d_2918_7926"
          x="622.715"
          y="745.167"
          width="98.5714"
          height="101.667"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="20" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.9 0 0 0 0 0.762353 0 0 0 0 0.278824 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2918_7926"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2918_7926"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_d_2918_7926"
          x="565.352"
          y="520.723"
          width="100.622"
          height="112.985"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="20" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2918_7926"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2918_7926"
            result="shape"
          />
        </filter>
        <filter
          id="filter5_d_2918_7926"
          x="234.25"
          y="671.25"
          width="102.5"
          height="102.5"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="20" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.303333 0 0 0 0 0.7 0 0 0 0 0.586667 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2918_7926"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2918_7926"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_2918_7926"
          x1="472.5"
          y1="1129"
          x2="472.5"
          y2="887"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0.1" />
          <stop offset="1" stopOpacity="0.3" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_2918_7926"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(472 472) rotate(90) scale(372)"
        >
          <stop stopColor="#288F89" />
          <stop offset="1" stopColor="#2F3674" stopOpacity="0" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export default DashboardMeditationBG;
